import React, { Component } from 'react';
import vmsg from 'vmsg'
import axios from 'axios'
import { LoadingComponent } from '../LoadingComponent';
import { MicrophoneIcon } from '@heroicons/react/20/solid';
import supabaseClient from '../../utils/supabaseInit';

const { data } = await supabaseClient.auth.getSession()
const recorder = new vmsg.Recorder({ wasmURL: 'https://unpkg.com/vmsg@0.3.0/vmsg.wasm' })
const sendMediaUrl = `https://${import.meta.env.VITE_COVENTIA_WA_URL}/sendmedia`

class Recorder extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isRecording: false,
            audioChunks: [],
            sending: false,
        };

    }
    sendMedia = async (file) => {
        const { data } = await supabaseClient.auth.getSession()
        const access_token = data.session.access_token
        const formData = new FormData();
        formData.append('file', file);
        formData.append('wa_id', this.props.user)
        try {
            this.setState({ sending: true })
            const response = await axios.post(sendMediaUrl, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': access_token,
                }
            });
            this.setState({ sending: false })
        } catch (error) {
            console.error('Failed:', error);
        }
    }
    record = async () => {
        this.setState({ isLoading: true })
        if (this.state.isRecording) {
            const blob = await recorder.stopRecording()
            const file = new File([blob], 'audio.mp3', { type: "audio/mp3" })
            this.sendMedia(file)

            this.setState({
                isLoading: false,
                isRecording: false,
                audioChunks: this.state.audioChunks.concat(URL.createObjectURL(blob))
            })
        }
        else {
            try {
                await recorder.initAudio()
                await recorder.initWorker()
                recorder.startRecording()
                this.setState({
                    isLoading: false,
                    isRecording: true,
                })
            } catch (error) {
                console.log(error)
                this.setState({
                    isLoading: false,
                    isRecording: false,
                })
            }
        }
    }

    render() {
        const { isRecording, sending, isLoading } = this.state;
        return (

            <div onClick={() => this.record()} style={{ width: '25px', height: "25px" }}>
                {isRecording
                    ?
                    isLoading
                        ?
                        <svg aria-hidden="true" className="w-6 h-6 text-white animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                            <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                        </svg>
                        :
                        <svg className="w-6 h-6 text-white dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" d="M5 11.917 9.724 16.5 19 7.5" />
                        </svg>
                    :
                    sending
                        ?
                        <svg aria-hidden="true" className="w-6 h-6 text-white animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                            <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                        </svg>
                        :
                        <MicrophoneIcon className="w-6 h-6 text-white dark:text-white" />

                }
            </div>


        );
    };
}

export default Recorder;
